module.exports = __webpack_public_path__ + "img/img-archive02.d2dbf8e5.png";